import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b31a5b6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6b31a5b6&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=6b31a5b6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31a5b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b31a5b6')) {
      api.createRecord('6b31a5b6', component.options)
    } else {
      api.reload('6b31a5b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b31a5b6&scoped=true&", function () {
      api.rerender('6b31a5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/components/TagsView/index.vue"
export default component.exports